import { Job } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

Job.Actions = {
  dispatcher: function() {
    return Job.Dispatcher;
  },

  resetData: function() {
    this.dispatcher().dispatch({
      type: 'job:data:reset'
    })
  },

  updateLocation: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:location_changed',
      value: val
    })

    this.fetchPhoneVerificationRequired(val.id)
  },

  updatePhoneVerificationRequired: function(suburbId, val) {
    this.dispatcher().dispatch({
      type: 'job:data:phone_verification_required_update',
      suburbId: suburbId,
      value: val
    })
  },

  fetchPhoneVerificationRequired: function(suburbId) {
    var normalizedSuburbId = Number(suburbId)

    this.updatePhoneVerificationRequired(normalizedSuburbId, false)

    if (!normalizedSuburbId) {
      return
    }

    $.ajax({
      url: '/job_wizard/phone_verification_required',
      dataType: 'json',
      data: { suburb_id: normalizedSuburbId }
    }).done(function(result) {
      this.updatePhoneVerificationRequired(normalizedSuburbId, result.phone_verification_required === true)
    }.bind(this)).fail(function() {
      this.updatePhoneVerificationRequired(normalizedSuburbId, false)
    })
  },

  updateCategory: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:category_changed',
      value: val
    })
  },

  updateDescription: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:description_changed',
      value: val
    })
  },

  uploadFiles: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:file_uploaded',
      value: val
    })
  },

  updateBudgetInMind: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:budgetinmind_changed',
      value: val
    })
  },

  updateBudgetType: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:budgettype_changed',
      value: val
    })
  },

  updateBudgetPriceRange: function(min, max) {
    this.dispatcher().dispatch({
      type: 'job:data:budgetpricerange_changed',
      value: { minimumBudget: min, maximumBudget: max }
    })
  },

  updateBudgetSetPriceRange: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:budgetsetpricerange_changed',
      value: val
    })
  },

  updateSubCategory: function(val, action, subcategoryType) {
    var type = (action ==  'add') ? 'job:data:subcategory_added' : 'job:data:subcategory_removed'
   
    this.dispatcher().dispatch({
      type: type,
      value: val,
      subcategoryType: subcategoryType
    })
  },

  resetCategories: function() {
    this.dispatcher().dispatch({
      type: 'job:data:categories_reset'
    })
  },

  updateKeyword: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:keyword_changed',
      value: val
    })
  },

  updateContactOptions: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:contactoptions_update',
      value: val
    })
  },

  updateSchedule: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:schedule_changed',
      value: val
    })
  },

  updateScheduleDate: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:scheduledate_changed',
      value: val
    })
  },

  updateScheduleTime: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:scheduletime_changed',
      value: val
    })
  },

  updateEmailAddress: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:email_changed',
      value: val
    })
  },

  addExtraDetails: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:extra_details_add',
      value: val
    })
  },

  removeExtraDetails: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:extra_details_remove',
      value: val
    })
  },

  updateSiteVisit: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:sitevisit_changed',
      value: val
    })
  },

  updateSiteVisitTime: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:sitevisittime_changed',
      value: val
    })
  },

  updateState: function() {
    this.dispatcher().dispatch({
      type: 'job:data:update_state',
      value: null
    })
  },

  urgentProductAdd: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:urgent_product_add',
      value: val
    })
  },

  updateOriginName: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:originname_changed',
      value: val
    })
  },

  updateContactPreference: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:contact_preference_changed',
      value: val
    })
  },

  updateQuoteEstimate: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:quote_estimate_changed',
      value: val
    })
  },

  updatePhoneNumber: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:phone_number_update',
      value: val
    })
  },

  updatePhoneNumberEditRequested: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:phone_number_edit_requested_update',
      value: val
    })
  },

  updateOmniAuthDetails: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:omni_auth_details_update',
      value: val
    })
  },

  resetOmniAuthDetails: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:omni_auth_details_reset',
      value: val
    })
  },

  updateMustCreateAccount: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:must_create_account_update',
      value: val
    })
  },

  updateFirstName: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:first_name_update',
      value: val
    })
  },

  updateBackToSubmit: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:back_to_submit_update',
      value: val
    })
  },

  updateFileNames: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:file_names_update',
      value: val
    })
  },

  updateOmniAuthProvider: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:omni_auth_provider_update',
      value: val
    })
  },

  updateLastSlide:  function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:last_slide_update',
      value: val
    })
  },

  updateFromPriceCalculator: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:from_price_calculator',
      value: val
    })
  },

  updateOtp: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:otp_update',
      value: val
    })
  },

  updateAdditionalQuestion: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:additional_question_update',
      value: val
    })
  },

  updateClosureSurvey: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:closure_survey_update',
      value: val
    })
  },

  updateProgressWidth: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:progress_width_update',
      value: val
    })
  },

  updateChoseMoreDetails: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:chose_more_details_update',
      value: val
    })
  },

  updatePreferredOutcome: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:preferred_outcome_update',
      value: val
    })
  },

  updateResetEmailAddressSlide: function(val) {
    this.dispatcher().dispatch({
      type: 'job:data:reset_email_address_slide',
      value: val
    })
  }
}
